import * as types from './types';
import * as managerTypes from '../manager/types';

const INITIAL_STATE = {
  chatList: null,
  chatNotifications: [],
  connectionStatus: {},
  socketConnection: null,
  socketConnectionStatus: false,
};

// chatNotification object min signature
//  {
//    id: 3,
//    type: 'Chat',
//    equip_id
//    read: true,
//    timestamp: '2025-06-20T17:00:00Z'
// }
//  {
//    id: 3,
//    type: 'Dispatch',
//    equip_id
//    code_type
//    read: true,
//    timestamp: '2025-06-20T17:00:00Z'
// }

// Types
// Chat
// Dispatch

const unique = msgList => msgList.filter((item, index, self) => index === self.findIndex(t => (
  t.id === item.id
)));


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_CHAT_HISTORY: {
      const { room, history } = action.payload;
      if (state.chatList[room].historyLoaded) {
        return state;
      }
      const chat = state.chatList[room];
      const existingIds = new Set(state.chatList[room].messages.map(m => m.id));
      const newMessageList = [
        ...unique(history)
          .filter(m => !existingIds.has(m.id))
          .map(m => ({
            id: m.id,
            message: m.message,
            type: m.tablet ? 'received' : 'sended',
            sender: m.sender,
          })),
        ...state.chatList[room].messages,
      ];
      return {
        ...state,
        chatList: {
          ...state.chatList,
          [room]: {
            ...chat,
            messages: newMessageList,
            isReaded: true,
            historyLoaded: true,
          },
        },
      };
    }
    case types.RECEIVE_NEW_MESSAGE: {
      const {
        sender, message, type, id,
      } = action.payload;

      const chat = state.chatList[sender.room];
      const newMessageList = [
        ...state.chatList[sender.room].messages,
        {
          id,
          message,
          type,
          sender,
        },
      ];
      return {
        ...state,
        chatList: {
          ...state.chatList,
          [sender.room]: {
            ...chat,
            messages: unique(newMessageList),
            isReaded: type === 'sended',
          },
        },
      };
    }
    case types.READ_CHAT: {
      const room = action.payload;
      return {
        ...state,
        chatList: {
          ...state.chatList,
          [room]: { ...state.chatList[room], isReaded: true },
        },
      };
    }
    case types.SET_CONNECTION_STATUS: {
      return {
        ...state,
        connectionStatus: action.payload,
      };
    }
    case types.SET_SOCKET_CONNECTION: {
      return {
        ...state,
        socketConnection: action.payload,
      };
    }
    case managerTypes.SET_EQUIPMENTS_LIST: {
      return {
        ...state,
        chatList: action.payload.reduce((acc, equipment) => {
          acc[equipment.id] = {
            name: equipment.name,
            id: equipment.id,
            messages: [],
            isReaded: true,
            lastTimeReceived: null,
            id_equip: equipment.id_equip,
            active: equipment.active,
          };
          return acc;
        }, {}),
      };
    }
    case types.SET_CHAT_NOTIFICATION: {
      return {
        ...state,
        chatNotifications: [action.payload, ...state.chatNotifications],
      };
    }
    case types.SET_CHAT_NOTIFICATION_HISTORY: {
      return {
        ...state,
        chatNotifications: [...action.payload],
      };
    }
    case types.MARK_AS_READ:
      return {
        ...state,
        chatNotifications: state.chatNotifications.map(
          n => (n.id === action.payload
            ? { ...n, read: true }
            : n),
        ),
      };
    case types.MARK_ALL_AS_READ:
      return {
        ...state,
        chatNotifications: state.chatNotifications.map(
          n => (action.payload.includes(n.id)
            ? { ...n, read: true }
            : n),
        ),
      };
    default:
      return state;
  }
}
